import React, { ReactNode } from "react";
import styles from "./Modal.module.scss";
import Backdrop from "../backdrop";
import { CenterCenterContainer } from "@components/templates/layouts/center-center-container/center-center-container";

interface ModalPropTypes {
  children: ReactNode;
}

const cssClassName = "modal";

const Modal = ({ children }: ModalPropTypes) => {
  return (
    <div className={styles[cssClassName]}>
      <Backdrop />
      <CenterCenterContainer>
        <div className={`${styles[cssClassName]}__content`}>{children}</div>
      </CenterCenterContainer>
    </div>
  );
};

export default Modal;
